export const setScrollbarWidthProperty = (): void => {
  const outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.overflow = 'scroll'
  document.body.appendChild(outer)
  const inner = document.createElement('div')
  outer.appendChild(inner)
  const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth)
  outer.parentNode!.removeChild(outer)
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px')
}

export const scrollToAnchor = (duration: number, anchor: string): void => {
  const subScroll = (curOffset: number) => {
    window.scrollTo(0, curOffset)
  }
  const anchorOffset = document.querySelector(anchor)!.getBoundingClientRect().top + window.scrollY - 10
  let curTime = 0
  let curOffset = 0
  do {
    window.setTimeout(subScroll, Math.round(curTime), Math.round(curOffset))
    curTime += duration / 100
    curOffset += anchorOffset / 100
  } while (curOffset <= anchorOffset)
}
